var App = App || {};

App.WidgetForm = (function ($) {
    'use strict';

    function Init(selector) {
        const form = selector.find("form");

        // make file uploader "delete file" link keyboard accessible
        form
            .find(".ktc-uploader-text-button")
            .attr("href", "#")
            .on("click", function (e) { e.preventDefault(); });

        // if the form has been modified for custom validation, send it that way
        if (form.is("[data-zag-validate-form]")) {
            // formValidation expects a native DOM element, not a jQuery object
            form.each(function () {
                App.Initialization['component.formValidation'].initialize(this);
            });
        }
    }

    return {
        Init: Init
    };

})(jQuery);
